import { Link } from "react-router-dom";
import bannerBackground from "../assets/banner_background.webp";

export default function HeroSection() {
  return (
    <div className="w-screen relative h-[100vh] overflow-hidden">
      <img
        src={bannerBackground}
        className="w-full h-full object-cover"
        alt="Office environment"
      />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-5xl px-4">
          <div className="bg-white/30 backdrop-blur-md rounded-xl p-12 border border-white/30 shadow-2xl text-center">
            <h1 className="text-neutral text-4xl font-bold tracking-tight sm:text-6xl drop-shadow-lg">
              Simplify global trade with intelligent document creation and real-time data access
            </h1>
            <div className="mt-12">
              <Link
                to="/auth"
                className="bg-secondary/90 backdrop-blur-sm text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-secondary-dark/90 transition-colors duration-200 shadow-lg"
              >
                Sign up now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
